import React from 'react';

import { SortMode } from '@qality/common-model/src/sorting/Sort';

import {
  BottomTriangleStyled,
  IconContainerStyled,
  IconStyled,
  TopTriangleStyled,
} from './SortingIcon.styled';

type Props = {
  sortMode: SortMode;
};

export default function SortingIcon({ sortMode }: Props): JSX.Element {
  return (
    <IconContainerStyled>
      <IconStyled>
        <TopTriangleStyled sortMode={sortMode} />
        <BottomTriangleStyled sortMode={sortMode} />
      </IconStyled>
    </IconContainerStyled>
  );
}
